import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isCollapse: false,
        curPage: 1,
        formFilter: null,
        curServicePage: 1
    },
    mutations: {
        getCollapseStatus (state, isCollapse) {
            state.isCollapse = isCollapse
        },
        changeCollapseStatus (state, isCollapse) {
            state.isCollapse = isCollapse
        },
        changePage (state, page) {
            state.curPage = page
        },
        changeServicePage (state, page) {
            state.curServicePage = page
        },
        changeCondition (state, formFilter) {
            state.formFilter = formFilter
        },
        resetListCache (state) {
            state.curPage = 1
            state.curServicePage = 1
            state.formFilter = null
        }
    },
    actions: {
        changeCollapseStatus ({ commit, state }) {
            commit('changeCollapseStatus', !state.isCollapse)
        }
    }
})
